/**
 * GenerationOutputFormatSection
 *
 * Bildformat + PNG-Qualität (Experteneinstellungen). Ausgelagert aus
 * GenerationFormPromptSection.tsx (Dateigröße).
 */
import { useTranslation } from 'react-i18next';
import { Select } from '@/components/v2/ui';

// Werte muessen exakt dem Backend-Wertesystem von gemini-direct entsprechen
// (app/api/v2/gemini_helpers/image_processing.py::convert_image_format quality_map
// bzw. validate_image_format) - nicht dem aelteren User-Settings-Wertesystem.
const IMAGE_FORMATS = [
  { value: 'png', label: 'PNG (verlustfrei)' },
  { value: 'jpeg', label: 'JPG (komprimiert)' },
  { value: 'webp', label: 'WebP (modern)' },
];

const PNG_QUALITY_OPTIONS = [
  { value: 'very_high', label: 'Maximum (keine Kompression)' },
  { value: 'web', label: 'Web Optimiert' },
  { value: 'compact', label: 'Kompakt' },
  { value: 'minimal', label: 'Minimal' },
];

interface GenerationOutputFormatSectionProps {
  imageFormat: string;
  pngQuality: string;
  onImageFormatChange: (value: string) => void;
  onPngQualityChange: (value: string) => void;
}

export function GenerationOutputFormatSection({
  imageFormat,
  pngQuality,
  onImageFormatChange,
  onPngQualityChange,
}: GenerationOutputFormatSectionProps) {
  const { t } = useTranslation();

  return (
    <>
      <Select
        label="Bildformat"
        options={IMAGE_FORMATS}
        value={imageFormat}
        onValueChange={onImageFormatChange}
      />

      {imageFormat === 'png' && (
        <Select
          label={t('generation.pngQuality')}
          options={PNG_QUALITY_OPTIONS}
          value={pngQuality}
          onValueChange={onPngQualityChange}
        />
      )}
    </>
  );
}
